import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import {
  APP_CONFIG_INITIALIZER,
  AppConfigInitializer,
  AppConfigService,
  INIT_APP_CONFIG_PROVIDER,
} from '@core/app-config/data-access';

@NgModule()
export class AppConfigModule {
  constructor(@Optional() @SkipSelf() parentModule: AppConfigModule) {
    if (parentModule) {
      throw new Error('AppConfigModule is already loaded. Import it in the AppModule only!');
    }
  }

  static forRoot(initializer: AppConfigInitializer): ModuleWithProviders<AppConfigModule> {
    return {
      ngModule: AppConfigModule,
      providers: [
        AppConfigService,
        {
          provide: APP_CONFIG_INITIALIZER,
          useValue: initializer,
        },
        INIT_APP_CONFIG_PROVIDER,
      ],
    };
  }
}
